import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/dostavkee/_sidebar-layout/orders/')({
    beforeLoad: () => {
        throw redirect({ to: '/dostavkee/orders/active' })
    },
})
